// extracted by mini-css-extract-plugin
export default {"myBoxMain":"HomePageLayout_myBoxMain__4N3Jt"};